import { Button, Div, Text } from "atomize"
import { theme } from "./settings/config"
import { useContext } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons"
import { AnimatePresence, motion } from "framer-motion"
import Container from "./atoms/Container"
import PlayerTag from "./atoms/PlayerTag"
import { schoolContext } from "./providers/school.provider"
import PlayerDetails from "./player/PlayerDetails"
import PlayerLessons from "./player/PlayerLessons"
import TechnicalSheet from "./player/TechnicalSheet"
import PlayerActions from "./player/PlayerActions"
import {
	getPlayerFullName,
	getPlayerNickname,
	getPtrLevel,
	isArchivedPlayer,
} from "./utils/func.utils"

function Player({ playerData, isOpen, handleOpenPlayerActions, modalView }) {
	const { getSelectedSchool } = useContext(schoolContext)

	const isArchived = isArchivedPlayer(playerData)
	// il livello della scheda tecnica, per riconoscerlo già dall'elenco
	const ptrLevel = getPtrLevel(playerData.technicalSheet?.ptrLevel)

	return (
		<>
			<Div
				p="0.5rem 1rem"
				d="flex"
				justify="space-between"
				align="center"
				bg={modalView ? theme.colors.background : theme.colors.surface}
				onClick={() => !modalView && handleOpenPlayerActions(playerData.playerID)}>
				<Div d="flex" align="center" style={{ gap: "0.5rem", flexWrap: "wrap" }}>
					<Text
						textColor={theme.colors.gunmetal}
						textSize="subheader"
						textWeight="bold">
						{getPlayerFullName(playerData)}
					</Text>
					{getPlayerNickname(playerData) && (
						<PlayerTag
							text={getPlayerNickname(playerData)}
							bg={theme.colors.primary_light}
							textColor={theme.colors.primary}
						/>
					)}
					{ptrLevel && (
						<PlayerTag
							text={ptrLevel.label}
							title={`Livello PTR ${ptrLevel.label}`}
							bg={theme.colors.gunmetal_lighter}
							textColor={theme.colors.gunmetal}
						/>
					)}
					{isArchived && (
						<PlayerTag
							text="Archiviato"
							bg={theme.colors.gray_light}
							textColor={theme.colors.text_light}
						/>
					)}
				</Div>
				{!modalView && (
					<Button bg="black" m={{ l: "1rem" }} p="0" w="1rem" h="1rem" rounded="circle">
						<FontAwesomeIcon
							icon={faChevronCircleDown}
							color={theme.colors.primary_light}
							size="2xl"
							flip={isOpen && "vertical"}
						/>
					</Button>
				)}
			</Div>
			{!modalView && getSelectedSchool() && (
				<AnimatePresence>
					{isOpen && (
						<motion.div
							transition={{ ease: "easeInOut" }}
							initial={{ height: 0, opacity: 0, y: -20 }}
							animate={{ height: "auto", opacity: 1, y: 1 }}
							exit={{ height: 0, opacity: 0, y: -20 }}>
							<Container>
								<TechnicalSheet playerData={playerData} />
								<PlayerDetails playerData={playerData} />
								<PlayerLessons playerData={playerData} />
								<PlayerActions playerData={playerData} />
							</Container>
						</motion.div>
					)}
				</AnimatePresence>
			)}
		</>
	)
}

export default Player
